export const notificationTypes = {
  1: "Calendar items",
  2: "Chats to me",
  3: "Friend requests",
  4: "Confirmed friends from my request",
  5: "Group membership acceptance",
  6: "New KnowCred",
  7: "Course step grades",
  8: "Course completion grades",
  9: "Weekly Newsletter",
  10: "New Featured Products",
}
